module.exports = {
          srcSet: __webpack_public_path__ + "b1450e3868f742e5b8e10779dacc8602-24.png"+" 24w",
          images:[ {path: __webpack_public_path__ + "b1450e3868f742e5b8e10779dacc8602-24.png",width: 24,height: 25}],
          src: __webpack_public_path__ + "b1450e3868f742e5b8e10779dacc8602-24.png",
          toString:function(){return __webpack_public_path__ + "b1450e3868f742e5b8e10779dacc8602-24.png"},
          
          width: 24,
          height: 25
        }